/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import type { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

import * as ContainerUtils from '../container/container-utils';
import type { C11nEnv } from '../interpreter/c11n-env';

export const updateETagToReduxStore = (headers: RawAxiosResponseHeaders | AxiosResponseHeaders, c11nEnv: C11nEnv) => {
  ContainerUtils.updateRelatedContextEtag(c11nEnv.getContextName(), headers.etag);
  ContainerUtils.updateCaseContextEtag(c11nEnv.getContextName(), headers.etag);
};
